"use strict";

exports.__esModule = true;
var _ReportingPeriodContext = require("./ReportingPeriodContext");
Object.keys(_ReportingPeriodContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportingPeriodContext[key]) return;
  exports[key] = _ReportingPeriodContext[key];
});